import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Container from '@/components/landing/container'

import { HIRING_SECTORS } from '@/constants/landing'

const SectorsMarquee: FC = (): ReactNode => {
    return (
        <section id='sectors' aria-labelledby='sectors-title' className='bg-brand-navy py-6 text-white sm:py-7'>
            <Container className='flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-10'>
                <h2 id='sectors-title' className='shrink-0 text-xs font-semibold uppercase tracking-[0.2em] text-brand-teal-bright sm:text-sm'>
                    Sectors hiring the most
                </h2>

                <div className='relative min-w-0 flex-1 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_6%,black_94%,transparent)] motion-reduce:[mask-image:none]'>
                    <div className='flex w-max animate-marquee hover:[animation-play-state:paused] motion-reduce:w-auto motion-reduce:animate-none'>
                        {[0, 1].map(copy => (
                            <ul
                                key={copy}
                                aria-hidden={copy === 1 ? 'true' : undefined}
                                className={cn(
                                    'flex shrink-0 items-center motion-reduce:flex-wrap motion-reduce:gap-y-2',
                                    copy === 1 && 'motion-reduce:hidden'
                                )}
                            >
                                {HIRING_SECTORS.map(sector => (
                                    <li key={sector} className='flex items-center gap-5 whitespace-nowrap pr-5 text-[15px] font-medium text-white/90 sm:text-base'>
                                        {sector}
                                        <span aria-hidden='true' className='size-1.5 rounded-full bg-brand-orange' />
                                    </li>
                                ))}
                            </ul>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default SectorsMarquee
